import i18n from '@/Config/app/i18n';
import { AIActionHealthDto } from '@/Domain/api/Action/dto/Action.dto';

export const formatMissingValues = (names: string[]): string =>
  names.map((name) => `{{${name}}}`).join(', ');

export const getSkipReasonText = ({
  skip_reason,
  missing_values,
  skipped_conversations,
}: Pick<AIActionHealthDto, 'skip_reason' | 'missing_values' | 'skipped_conversations'>):
  | string
  | null => {
  switch (skip_reason) {
    case 'missing_values':
      return missing_values.length
        ? i18n.t('actions_page:health.skip_reason.missing_values', {
            count: skipped_conversations,
            values: formatMissingValues(missing_values),
          })
        : null;
    case 'invalid_configuration':
      return i18n.t('actions_page:health.skip_reason.invalid_configuration');
    case 'secret_unreadable':
      return i18n.t('actions_page:health.skip_reason.secret_unreadable');
    case 'server_unreachable':
      return i18n.t('actions_page:health.skip_reason.server_unreachable');
    case 'needs_reconnect':
      return i18n.t('actions_page:health.skip_reason.needs_reconnect');
    case null:
      return null;
    default: {
      const _: never = skip_reason;
      return null;
    }
  }
};
